<template>
    <v-row justify="center" class="membership-steps">
        <v-col v-for="(item, index) in items" :key="index" cols="12" md="6" lg="" class="text-center">
            <div class="tit tit--sm mb-12px mb-md-16px">
                <span class="primary--text" :class="`text--${item.color}`">STEP 0{{ index + 1 }}</span>
            </div>
            <v-sheet :color="`primary ${item.color}`" height="15" />
            <div class="tit tit--xs my-12px my-md-16px">
                {{ item.title }}
            </div>
            <div v-html="item.text" />
        </v-col>
    </v-row>
</template>

<script>
export default {
    data() {
        return {
            items: [
                {
                    color: "lighten-3",
                    title: "온라인 신청서 작성",
                    text: "<p class='txt'>파트너 전용 회원가입 <br>(사업자등록증 및 필요 정보 입력 <br class='d-none d-xl-block'>및 약관 동의)</p>",
                },
                {
                    color: "lighten-1",
                    title: "신청 검토 및 승인",
                    text: "<p class='txt'>내부 검토 후 1~2일 내 <br class='d-none d-md-block'>승인 여부 안내</p><p class='txt txt--xs'>(SMS/이메일로 통지)</p>",
                },
                {
                    title: "파트너 계정 개설",
                    text: "<p class='txt mb-12px mb-md-16px'>승인 시 파트너 전용 <br class='d-none d-md-block'>마이페이지 계정 <br class='d-none d-md-block'>발급 및 환영 안내 제공.</p><p class='txt txt--xs grey--text text--lighten-2'>초기 가이드나 교육자료를 <br>이단계에서 제공하여 <br>새 파트너가 제품 정보와 판매 방법을 숙지</p>",
                },
                {
                    color: "darken-2",
                    title: "판매 활동 시작",
                    text: "<p class='txt'>파트너는 사입 또는 위탁 거래를 통해 자체 판매 활동 시작</p>",
                },
                {
                    color: "darken-4",
                    title: "지속 지원",
                    text: "<p class='txt'>상시 상담가능 채널을 통해 <br>지속적인 소통 및 지원.</p>",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.membership-steps {
    margin: -20px !important;
    > [class*="col"] {
        padding: 20px !important;
    }
}
@media (min-width: 768px) {
    .membership-steps {
        margin: -20px 0 !important;
        > [class*="col"] {
            padding: 20px 0 !important;
        }
    }
}
@media (min-width: 1024px) {
    .membership-steps {
        margin: 0 !important;
        > [class*="col"] {
            padding: 0 !important;
        }
    }
}
</style>